/* eslint-disable */
// Accesos directos de la cabecera: mismas pantallas y nombres que el menú lateral
export const shortcuts = [
    {
        id         : '1',
        label      : 'Inicio',
        description: 'Resumen global',
        icon       : 'heroicons_outline:home',
        link       : '/home',
        useRouter  : true,
    },
    {
        id         : '2',
        label      : 'Proyectos',
        description: 'Gestión de proyectos',
        icon       : 'heroicons_outline:clipboard-document-check',
        link       : '/projects',
        useRouter  : true,
    },
    {
        id         : '3',
        label      : 'Honeytokens',
        description: 'Gestión de honeytokens',
        icon       : 'heroicons_outline:sparkles',
        link       : '/honeytokens-management',
        useRouter  : true,
    },
    {
        id         : '4',
        label      : 'Eventos',
        description: 'Eventos de seguridad',
        icon       : 'heroicons_outline:shield-exclamation',
        link       : '/security-events',
        useRouter  : true,
    },
    {
        id         : '5',
        label      : 'Alertas',
        description: 'Alertas de seguridad',
        icon       : 'heroicons_outline:bell-alert',
        link       : '/alerts',
        useRouter  : true,
    },
    {
        id         : '6',
        label      : 'Búsqueda de IPs',
        description: 'Inteligencia de amenazas',
        icon       : 'heroicons_outline:magnifying-glass-circle',
        link       : '/threat-intelligence/ip-analysis',
        useRouter  : true,
    },
];
